import { NotificationsRes } from '@/api/types/notificationsType';

export const applyLocalReadState = (
  notifications: NotificationsRes[],
  locallyReadIds: ReadonlySet<number>
): NotificationsRes[] =>
  notifications.map((notification) =>
    locallyReadIds.has(notification.id)
      ? { ...notification, is_read: true }
      : notification
  );
